import React from "react";
import {ReactComponent as IcVerified} from '../../assets/icons/ic-verified.svg'
import {ReactComponent as IcSpray} from '../../assets/icons/ic-spray.svg'
import {ReactComponent as IcThumbprice} from '../../assets/icons/ic-thumbprice.svg'



export const Reason = () => {
    const data = [
        {
            icon: <IcVerified />,
            tagline:'Produk 100% Original',
            desc: 'Kami hanya menyediakan bibit parfum asli dengan kualitas terjamin, sehingga Anda bisa menikmati aroma premium yang tahan lama.'
        },
        {
            icon: <IcSpray />,

            tagline:'Aroma Bervariatif',
            desc: 'Temukan koleksi aroma beragam, mulai dari segar, manis, hingga elegan, yang dirancang untuk melengkapi setiap momen Anda.'
        },
        {
            icon: <IcThumbprice />,
            tagline:'Harga Terjangkau',
            desc: 'Nikmati keharuman mewah tanpa harus merogoh kantong dalam-dalam. Kualitas terbaik, harga terbaik.'
        },
    ]
    return (
        <div className="grid gap-4 md:gap-6 p-4 sm:p-6 md:p-8 lg:p-10">
            <div className="text-center lg:text-left">
                <p className="text-[#548CA8] text-sm sm:text-base">Why Agiros</p>
                <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mt-2 max-w-4xl lg:max-w-none mx-auto lg:mx-0 leading-tight">
                    Kenapa Memilih Agiros Perfume? Temukan Alasannya
                </h1>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6 mt-4 md:mt-6">
                {data.map((item, index) => (
                    <div 
                        key={index}
                        className="grid gap-3 sm:gap-4 text-left border border-[#E5E5E5] p-4 sm:p-5 md:p-6 rounded-lg hover:shadow-md transition-shadow duration-200 bg-white"
                    >
                        <div className="flex space-x-2 sm:space-x-3 items-center">
                            <div className="rounded-full p-2 sm:p-2.5 md:p-3 bg-[#F5F5F5] flex-shrink-0">
                                <div className="w-7 h-7">
                                    {item.icon}
                                </div>
                            </div>
                            <h1 className="text-sm sm:text-base md:text-lg font-medium leading-tight">
                                {item.tagline}
                            </h1>
                        </div>
                        <p className="text-xs sm:text-sm md:text-base text-[#404040] leading-relaxed">
                            {item.desc}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}